import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function ComparisonTable() {
  const features = [{
    name: '6 Tomos psicopedagógicos completos',
    basic: true,
    pro: true
  }, {
    name: '6 Bonos imprimibles',
    basic: true,
    pro: true
  }, {
    name: 'Plantillas de informes y rúbricas',
    basic: true,
    pro: true
  }, {
    name: 'Material listo para imprimir',
    basic: true,
    pro: true
  }, {
    name: 'Fichas de seguimiento individual',
    basic: true,
    pro: true
  }, {
    name: 'Actualizaciones del MegaPack',
    basic: true,
    pro: true
  }, {
    name: 'PRO 🧠 Módulo 1: Memoria PRO',
    basic: false,
    pro: true
  }, {
    name: 'PRO 🎯 Módulo 2: Atención PRO',
    basic: false,
    pro: true
  }, {
    name: 'PRO 🗣️ Módulo 3: Lenguaje PRO',
    basic: false,
    pro: true
  }, {
    name: 'PRO 📖 Módulo 4: Lectoescritura PRO',
    basic: false,
    pro: true
  }, {
    name: 'PRO 🔢 Módulo 5: Lógica Matemática PRO',
    basic: false,
    pro: true
  }, {
    name: 'PRO 🧩 Módulo 6: Funciones Ejecutivas PRO',
    basic: false,
    pro: true
  }];
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-20 bg-white" data-id="element-33">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-34">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-35">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-gray-100 text-gray-800 font-bold text-sm mb-4" data-id="element-36">
            ⚔️ Comparación directa
          </div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4" data-id="element-37">
            La diferencia es brutal
          </h2>
          <p className="text-xl text-gray-600" data-id="element-38">
            Mirá lo que te perdés si elegís solo lo Esencial.
          </p>
        </motion.div>

        <div className="bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden" data-id="element-39">
          <div className="grid grid-cols-3 bg-gray-50 border-b border-gray-200" data-id="element-40">
            <div className="p-4 md:p-6 font-bold text-gray-900 flex items-center" data-id="element-41">
              Lo que incluye
            </div>
            <div className="p-4 md:p-6 text-center border-l border-gray-200" data-id="element-42">
              <div className="text-gray-500 font-bold text-sm mb-1" data-id="element-43">
                Esencial
              </div>
              <div className="text-xl font-black text-gray-900" data-id="element-44">$19.990</div>
            </div>
            <div className="p-4 md:p-6 text-center border-l border-gray-200 bg-brand-50 relative" data-id="element-45">
              <div className="absolute top-0 left-0 w-full h-1 bg-brand-600" data-id="element-46"></div>
              <div className="text-brand-600 font-bold text-xs uppercase tracking-wider mb-1" data-id="element-47">
                Recomendado
              </div>
              <div className="text-brand-800 font-bold text-sm mb-1" data-id="element-48">
                + PLAN PRO
              </div>
              <div className="text-xl font-black text-brand-900" data-id="element-49">$27.990</div>
            </div>
          </div>

          <div className="divide-y divide-gray-100" data-id="element-50">
            {features.map((feature, idx) => <div key={idx} className="grid grid-cols-3 hover:bg-gray-50 transition-colors" data-id="element-51">
                <div className="p-4 md:p-5 text-sm md:text-base text-gray-700 flex items-center" data-id="element-52">
                  {feature.name.startsWith('PRO') ? <span className="font-semibold text-brand-700" data-id="element-53">
                      {feature.name}
                    </span> : feature.name}
                </div>
                <div className="p-4 md:p-5 flex items-center justify-center border-l border-gray-100" data-id="element-54">
                  {feature.basic ? <Check className="w-5 h-5 text-success" data-id="element-55" /> : <X className="w-5 h-5 text-gray-300" data-id="element-56" />}
                </div>
                <div className="p-4 md:p-5 flex items-center justify-center border-l border-gray-100 bg-brand-50/30" data-id="element-57">
                  {feature.pro ? <Check className="w-5 h-5 text-brand-600" data-id="element-58" /> : <X className="w-5 h-5 text-gray-300" data-id="element-59" />}
                </div>
              </div>)}

            {/* Total Row */}
            <div className="grid grid-cols-3 bg-gray-50 font-bold" data-id="element-60">
              <div className="p-4 md:p-6 text-gray-900 flex items-center" data-id="element-61">
                Total incluido
              </div>
              <div className="p-4 md:p-6 text-center border-l border-gray-200 text-gray-500 text-xl" data-id="element-62">
                6/12
              </div>
              <div className="p-4 md:p-6 text-center border-l border-gray-200 bg-brand-100 text-brand-800 text-2xl" data-id="element-63">
                12/12
              </div>
            </div>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-8 bg-brand-50 rounded-2xl p-6 md:p-8 text-center border border-brand-200" data-id="element-64">
          <p className="text-lg text-brand-900 font-medium mb-6" data-id="element-65">
            Por solo <strong data-id="element-66">$8.000 más</strong> sumás 6 módulos PRO exclusivos
            que te ahorran horas cada semana.
          </p>
          <button onClick={scrollToPricing} className="bg-brand-600 hover:bg-brand-700 text-white font-bold py-3 px-8 rounded-xl shadow-md transition-colors inline-flex items-center gap-2" data-id="element-67">
            👉 Quiero el PLAN PRO
          </button>
        </motion.div>
      </div>
    </section>;
}